module.exports = __webpack_public_path__ + "img/logo-stamp.54026b16.png";